export enum DashRegistrationStep {    
    GetStarted = 0,
    QuickStart = 1,
    BasicDetails = 5,
    AcceptTransfusions = 10,
    AssessOrganDisease = 15,
    AssessHeartAttack = 20,
    AssessDiabetes = 25,
    AssessBloodPressure = 30,
    AssessCancer = 35,
    AssessKidneyStones = 40,
    PregnantOrNursing = 45,
    AssessTobacco = 50,
    DonationDetails = 55,
    ScreeningComplete = 100,
    HistoryDemographics = 105,
    HistoryDiagnosed = 110,
    HistoryFamily = 115,
    HistoryMisc = 120,
    HistorySocial = 125,
    PreWorkupLabs = 150,
    SelectCenter = 195,
    NkrCenters = 198,
    HistoryComplete = 200,
    PendingEmr = 1000,
    PendingContact = 1005,
    PendingWorkup = 1020,
    PendingPreOp = 1025,
    PendingSurgery = 1030,
    SurgeryComplete = 1035,
    SurveyComplete = 1040,
    Completed = 1500,
    AutoRuledOut = 2000,
    ManuallyRuledOut = 2001,
    TempRuleOut = 2002,
    LocationRuleOut = 2003,
    ExpiredRuleOut = 2004,
    Transferred = 3000
}